import { useLocation, useNavigate } from "react-router-dom";

import ProfileWizard from "../components/ProfileWizard";

type ProfileRouteState = {
  returnTo?: string;
};

export default function ProfileSettings() {
  const navigate = useNavigate();
  const location = useLocation();
  const routeState = (typeof location.state === "object" && location.state ? location.state : {}) as ProfileRouteState;
  const returnTo = String(routeState.returnTo || "/home");

  const closePage = () => {
    navigate(returnTo, { replace: true });
  };

  return <ProfileWizard mode="settings" onComplete={closePage} onCancel={closePage} />;
}
